import * as Yup from "yup";

export const OnBehalfSchema = Yup.object().shape({
  name: Yup.string().required("Email is required"),
});
